import React, { useState, useEffect } from 'react';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import itemService from '../../service/item.service';
import { ItemGroupTypeList, StockArticleTypeList } from '../../config/itemGroup';
import useGenerateJokerReportCols from '../../hooks/useGenerateJokerReportCols';

export default function ItemReports({
  refetch,
  values,
  viewField,
  operatorsDisabled,
  rowSelection,
  autocompleteOptions,
  jokerFields,
}) {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'itemCode', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    itemService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const jokerCols = useGenerateJokerReportCols(jokerFields);

  const columns = dataGridPremiumColumns([
    {
      field: 'itemCode',
      headerName: 'Cikkszám',
      type: 'string',
    },
    {
      field: 'itemName',
      headerName: 'Cikknév',
      type: 'string',
    },
    {
      field: 'itemGroupId',
      type: 'singleSelect',
      headerName: 'Cikkcsoport',
      renderCell: (data) => {
        return data.row.itemGroup?.name;
      },
      valueOptions: autocompleteOptions.itemGroup,
    },
    {
      field: 'quantityUnitId',
      type: 'singleSelect',
      headerName: 'Mennyiségi egység',
      renderCell: (data) => {
        return data.row.quantityUnit?.name;
      },
      valueOptions: autocompleteOptions.quantityUnit,
    },
    {
      field: 'type',
      headerName: 'Típus',
      type: 'singleSelect',
      valueOptions: ItemGroupTypeList,
    },
    {
      field: 'stockItemType',
      headerName: 'Készletcikk fajta',
      type: 'singleSelect',
      valueOptions: StockArticleTypeList,
    },
    {
      field: 'inPurchase',
      headerName: 'Beszerzésben részt vesz',
      type: 'boolean',
    },
    {
      field: 'inSales',
      headerName: 'Értékesítésben részt vesz',
      type: 'boolean',
    },
    {
      field: 'weight',
      headerName: 'Súly (kg)',
      type: 'number',
    },
    {
      field: 'kshClassificationId',
      type: 'singleSelect',
      headerName: 'KSH besorolás',
      renderCell: (data) => {
        return data.row.kshClassification?.name;
      },
      valueOptions: autocompleteOptions.kshClassification,
    },
    {
      field: 'other',
      headerName: 'Egyéb',
      type: 'string',
    },
    {
      field: 'active',
      headerName: 'Aktív',
      type: 'boolean',
    },
    {
      field: 'barCode',
      headerName: 'Vonalkód',
      type: 'string',
    },
    {
      field: 'landedCost',
      headerName: 'Mellékköltség',
      type: 'boolean',
    },
    {
      field: 'purchaseVatCode',
      headerName: 'Beszerzés ÁFA kód',
      type: 'singleSelect',
      renderCell: (data) => {
        return data.row.purchaseVat?.code ? `${data.row.purchaseVat?.code} - ${data.row.purchaseVat?.name}` : '';
      },
      valueOptions: autocompleteOptions.purchaseVatCode,
    },
    {
      field: 'salesVatCode',
      headerName: 'Értékesítés ÁFA kód',
      type: 'singleSelect',
      renderCell: (data) => {
        return data.row.salesVat?.code ? `${data.row.salesVat?.code} - ${data.row.salesVat?.name}` : '';
      },
      valueOptions: autocompleteOptions.salesVatCode,
    },
    ...jokerCols,
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.item}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      getRowId={(row) => row.itemCode}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
}
